// --- Our Modules --------------------------------------------------------------------------------
import useTranslation from "@/hooks/useTranslation";
import type { TyStatsRange, TySubscriptionPeriod } from "@/types";
import { rangeLabel } from "./helpers";

// --- Types --------------------------------------------------------------------------------------

type Props = {
    ranges: TyStatsRange[];
    range: TyStatsRange;
    onRangeChange: (range: TyStatsRange) => void;

    /** Absent for an admin who cannot see the subscriptions section — there is nothing to scope. */
    periods?: TySubscriptionPeriod[];
    period: TySubscriptionPeriod | "";
    onPeriodChange: (period: TySubscriptionPeriod | "") => void;
};

// --- Logic --------------------------------------------------------------------------------------

/**
 * One filter row above everything, which is what makes the whole screen read as a single answer: the
 * cards and the charts are all cut by the window named here, so there is never a card whose period the
 * admin has to go and check.
 */
export default function RangeBar({ ranges, range, onRangeChange, periods, period, onPeriodChange }: Props) {
    const t = useTranslation();

    return (
        <div className="home-range">
            <div className="home-range-group" role="group" aria-label={t.home.title}>
                {ranges.map((one) => (
                    <button
                        key={one}
                        type="button"
                        className="home-range-chip"
                        data-active={one === range}
                        aria-pressed={one === range}
                        onClick={() => onRangeChange(one)}
                    >
                        {rangeLabel(one, t)}
                    </button>
                ))}
            </div>

            {periods && periods.length > 0 && (
                <div className="home-range-group" role="group" aria-label={t.home.subsByPeriod}>
                    <button
                        type="button"
                        className="home-range-chip"
                        data-active={period === ""}
                        aria-pressed={period === ""}
                        onClick={() => onPeriodChange("")}
                    >
                        {t.home.periodAll}
                    </button>
                    {periods.map((one) => (
                        <button
                            key={one}
                            type="button"
                            className="home-range-chip"
                            data-active={one === period}
                            aria-pressed={one === period}
                            onClick={() => onPeriodChange(one)}
                        >
                            {t.enums.subscriptionPeriod[one]}
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
}
